import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  name: {
    default: 'Access Super App',
    editor: 'textbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-top-navbar where you can change all the attributes',
  coreComponent: {
    html: `<tag-top-navbar{{...knobs}}>
</tag-top-navbar>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: { jsx: `<TagTopNavbar{{...knobs}} />`, knobs: PlaygroundKnobs },
};

export const TagTopNavbarDocs: Component = {
  type: 'component',
  name: 'top-navbar',
  description: 'Renders a nav bar to go at the top of the page',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The name of the app the nav is for',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
